export default __webpack_public_path__ + "static/media/dummy-image.456bbf6f.jpg";